var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTimesheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.21094 8.21094C8.57812 7.84766 9.17188 7.84766 9.50391 8.21094L12.6289 11.3359C13.0273 11.7031 13.0273 12.2969 12.6289 12.6289C12.2969 13.0273 11.7031 13.0273 11.3359 12.6289L8.21094 9.50391C7.84766 9.17188 7.84766 8.57812 8.21094 8.21094Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.75 3.25C10.75 2.55977 11.3086 2 12 2C17.5234 2 22 6.47656 22 12C22 17.5234 17.5234 22 12 22C6.47656 22 2 17.5234 2 12C2 9.20312 3.15078 6.67188 5.00156 4.85703C5.49453 4.37422 6.28516 4.38203 6.76953 4.875C7.25391 5.36836 7.24609 6.16016 6.75 6.64453C5.36055 8.00391 4.5 9.90234 4.5 12C4.5 16.1406 7.82422 19.5 12 19.5C16.1406 19.5 19.5 16.1406 19.5 12C19.5 8.28516 16.7969 5.19883 13.25 4.60352V5.75C13.25 6.44141 12.6914 7 12 7C11.3086 7 10.75 6.44141 10.75 5.75V3.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimesheet);
export default __webpack_public_path__ + "static/media/icon-timesheet.d710014235c7161cc2bfd902757d50de.svg";
export { ForwardRef as ReactComponent };